import { columns } from './properties/columns'

export const state = {
    list: [],
    columns: columns,
    defaultColumns: JSON.parse(JSON.stringify(columns)),
};
